const React = require('react')

import {
  Button,
  Popover,
} from 'react-bootstrap'

export default class FrogPlayPopover extends React.Component {
  render() {
    return (
       <Popover
        id="frogplay-popover"
        placement="bottom"
        positionTop={30}
        title="Welcome from FrogPlay"
      >
        <p>
          Welcome to Boost! We&apos;ve filtered the results to match the quiz you were taking.
        </p>
        <p>
          Change or reset these filters to search other sites!
        </p>
        <div>
          <Button
            bsStyle='primary'
            onClick={this.props.onClose}
          >
            OK!
          </Button>
        </div>
      </Popover>
    )
  }
}